import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule,  ServiceResponseModule } from '@sdbn/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TruckSupplementaryEquipmentComponent } from './component/supplementary-equipment/truck-supplementary-equipment.component';
import { TruckDetailsDialogComponent } from './component/truck-details-dialog/truck-details-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    ReactiveFormsModule,
    CommonUIModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatDialogModule,

    MatFormFieldModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatCheckboxModule
  ],
  declarations: [
    TruckDetailsDialogComponent,
    TruckSupplementaryEquipmentComponent
  ]
})
export class TruckModule { }
